module.exports = __webpack_public_path__ + "static/media/earthi-rev.3d1e0b6b.png";